export enum ResourceCategoryTypes {
    LOGO = "logo",
    FAVICON = "favicon",
    HEADER_LOGO = "header-logo",
    PRE_FORM_CONTENT = "pre-form-content",
    POST_FORM_CONTENT = "post-form-content",
    POST_SUBMIT_CONTENT = "post-submit-content",
    BACKGROUND_IMAGES = "background-images",
    DCUI_HEADER_LOGO = "dcui-header-logo",
    DCUI_START_INSTRUCTION_IMAGES = "dcui-start-instructions-images",
    DCUI_CUSTOM_MEDIAS = "dcui-custom-medias"
}